export default __webpack_public_path__ + "static/media/aquaculture.262c8e53.jpg";